import React from 'react'
import { useSelector } from 'react-redux'
import { ws } from 'src/functions/ws'
import { IState } from 'src/models/state'

export const CustodyMain = () => {

	const brlLogo = require('../images/BRL.svg')
	const linkLogo = require('../images/LINK.svg')
	const usdcLogo = require('../images/USDC.svg')
	const btcLogo = require('../images/bitcoin.svg')
	const ltcLogo = require('../images/litecoin.svg')
	const dogeLogo = require('../images/dogecoin.svg')
	const ethLogo = require('../images/ethereum.svg')
	const ebitLogo = require('../images/ebit.svg')

	const custody = useSelector((state: IState) => state.custody)

	React.useEffect(
		() => {
			ws.send({ type: 'Custody.Get' } as any)
		},
		[])

	return (
		<div className='walletsMain'>
			<span className='pageTitle'>Custody</span>
			<span className='pageBoxTitle'>Fiat</span>
			<div>
				<table className='walletsTableMain'>
					<thead>
						<tr className='walletsTableHeaderRow'>
							<td className='walletsTableHeaderRowItem coinColumn'>Coin</td>
							<td className='walletsTableHeaderRowItem coinNameColumn'>Name</td>
							<td className='walletsTableHeaderRowItem balanceColumn'>Total</td>
						</tr>
					</thead>
					<tbody>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><img src={brlLogo} className='walletsLogo' alt='BRL' />BRL</td>
							<td className='walletsTableBodyRowItem'>Brazilian Real</td>
							<td className='walletsTableBodyRowItem'>{custody.BRL?.toFixed(2)}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<br /><br />
			<span className='pageBoxTitle'>Crypto</span>
			<div>
				<table className='walletsTableMain'>
					<thead>
						<tr className='walletsTableHeaderRow'>
							<td className='walletsTableHeaderRowItem coinColumn'>Coin</td>
							<td className='walletsTableHeaderRowItem coinNameColumn'>Name</td>
							<td className='walletsTableHeaderRowItem balanceColumn'>Total</td>
						</tr>
					</thead>
					<tbody>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><img src={btcLogo} className='walletsLogo' alt='BTC' /> BTC</td>
							<td className='walletsTableBodyRowItem'>Bitcoin</td>
							<td className='walletsTableBodyRowItem'>{custody.BTC?.toFixed(8)}</td>
						</tr>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><img src={ethLogo} className='walletsLogo' alt='ETH' /> ETH</td>
							<td className='walletsTableBodyRowItem'>Ethereum</td>
							<td className='walletsTableBodyRowItem'>{custody.ETH?.toFixed(8)}</td>
						</tr>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><img src={ebitLogo} className='walletsLogo' alt='EBIT' /> EBIT</td>
							<td className='walletsTableBodyRowItem'>Econobit</td>
							<td className='walletsTableBodyRowItem'>{custody.EBIT?.toFixed(8)}</td>
						</tr>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><img src={ltcLogo} className='walletsLogo' alt='LTC' /> LTC</td>
							<td className='walletsTableBodyRowItem'>Litecoin</td>
							<td className='walletsTableBodyRowItem'>{custody.LTC?.toFixed(8)}</td>
						</tr>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><img src={dogeLogo} className='walletsLogo' alt='DOGE' /> DOGE</td>
							<td className='walletsTableBodyRowItem'>Dogecoin</td>
							<td className='walletsTableBodyRowItem'>{custody.DOGE?.toFixed(8)}</td>
						</tr>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><img src={usdcLogo} className='walletsLogo' alt='USDC' /> USDC</td>
							<td className='walletsTableBodyRowItem'>USD Coin</td>
							<td className='walletsTableBodyRowItem'>{custody.USDC?.toFixed(8)}</td>
						</tr>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><img src={linkLogo} className='walletsLogo' alt='LINK' /> LINK</td>
							<td className='walletsTableBodyRowItem'>Econobit</td>
							<td className='walletsTableBodyRowItem'>{custody.LINK?.toFixed(8)}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/custodyMain.tsx